export default {
  route: {
    shareRevoked: '所有者がこのリンクの共有を停止しました。',
    invalidUrl: 'このURLは有効なプロジェクトを指していません。',
    notFound: 'このジオメトリは存在しないか、アクセス権限がありません。',
  },
  dashboard: {
    columnName: '名前',
    columnStatus: 'ステータス',
    columnCreated: '作成日時',
    columnCompleted: '完了日時',
    columnUpdated: '更新日時',
    columnActions: '操作',
    saveName: '名前を保存',
    cancel: 'キャンセル',
    uploadTitle: 'CADファイルをドロップしてメッシュ化',
    uploadSubtitle: 'STEP、STP、OBJ、またはSTL — 最大1 GB',
    controlsTitle: 'メッシュ',
    countLabel_one: 'メッシュ {{count}} 件',
    countLabel_other: 'メッシュ {{count}} 件',
    searchPlaceholder: 'メッシュを検索…',
    typeFilter: 'タイプ',
    tagFilter: 'タグ',
    typeFea: 'FEA',
    typeCfd: 'CFD',
    typeCht: 'CHT',
    tagCfdExt: 'CFD · 外部',
    tagCfdInt: 'CFD · 内部',
    tagCht: 'CHT',
    tagFea: 'FEA',
    tagWrap: 'Wrap',
    tagRepair: 'Repair',
    tagTet: 'Tet',
    tagHex: 'Hex',
    tagPoly: 'Poly',
    noTypes: 'タイプがありません',
    noTags: 'タグがありません',
    clearFilter: 'フィルターをクリア',
    tabAll: 'すべて',
    tabMeshing: 'メッシュ化中',
    tabDone: '完了',
    tabFailed: '失敗',
    emptyTitleNone: 'メッシュはまだありません',
    emptyTitleFiltered: 'フィルターに一致するメッシュがありません',
    emptyHintNone: '上でCADファイルをアップロードしてメッシュ化を開始します。',
    emptyHintSearchMore:
      '読み込み済みのメッシュに一致するものがありません — スクロールしてさらに読み込むか、別の検索をお試しください。',
    emptyHintFiltered: '別のフィルターまたは検索キーワードをお試しください。',
    loadingLabel: 'メッシュを読み込み中…',
    tableEmpty: '利用可能なメッシュはまだありません。',
  },
  rowActions: {
    publicTooltip: '公開 — リンクを知っている人は誰でも閲覧できます',
    privateTooltip: '非公開 — あなたのチームのみが閲覧できます',
    public: '公開',
    private: '非公開',
    downloadReady: 'メッシュ結果をダウンロード',
    downloadDisabled: 'ステータスが「完了」の場合のみダウンロードできます',
    downloadMeshResult: 'メッシュ結果をダウンロード',
    chooseFormat: 'ダウンロード形式を選択',
    downloadFormatMenu: 'ダウンロード形式',
    moreActions: 'その他の操作',
    actionsMenu: 'ジオメトリの操作',
    makePrivate: '非公開にする',
    makePublic: '公開する',
    copyPublicLink: '公開リンクをコピー',
    rename: '名前を変更',
    delete: '削除',
  },
  status: {
    processing: '処理中',
    error: '診断エラー',
    noMesh: 'メッシュなし',
    meshing: 'メッシュ化中',
    done: '完了',
    failed: '失敗',
  },
  deleteDialog: {
    title: 'このジオメトリを削除しますか？',
    descriptionSuffix:
      'とそこから生成されたメッシュは完全に削除されます。この操作は元に戻せません。',
    cancel: 'キャンセル',
    confirm: 'ジオメトリを削除',
  },
  sidebar: {
    renameTooltip: 'クリックしてプロジェクト名を変更',
  },
  rename: {
    notAvailable: '名前の変更はまだ利用できません — 近日公開予定です。',
    failed: '名前を変更できませんでした — もう一度お試しください。',
  },
  viewer: {
    loading: 'ビューアを読み込み中...',
  },
  workspace: {
    backToLibrary: 'メッシュ一覧に戻る',
  },
  restore: {
    title: 'セッションを復元中',
    subtitle: '以前の作業を読み込み中...',
    skip: 'スキップ — 最初から始める',
  },
  tree: {
    filesHeader: 'ファイル',
    modeLatest: '最新',
    modeAll: 'すべて',
    containerLabel: 'MeshGen ジオメトリツリー',
    mesh: 'メッシュ',
    refinement: '細分化',
    aiRetry: 'AI再試行',
    originRepaired: '自動修復されたジオメトリ',
    originManualRepaired: '修復されたジオメトリ',
    originUploaded: 'ユーザーがアップロードしたジオメトリ',
    // バージョンツリーの「簡略化候補」短ラベル. 「候補」の含意 (承認
    // 待ちの提案) が伝わりにくいのでツールチップで補足する.
    originSimplified: '簡略化候補',
    originRepairedTooltip:
      'このバージョンは前バージョンの CAD から自動修復されました。非多様体エッジ、ギャップ、不良面が修正され、トポロジーは元と同じです。',
    originManualRepairedTooltip:
      'このバージョンは修復のリクエストにより前バージョンの CAD から修復されました。非多様体エッジ、ギャップ、不良面が修正され、トポロジーは元と同じです。',
    originUploadedTooltip:
      'このバージョンはあなたがアップロードした CAD ファイルです。ビューアで確認するか、行メニューからダウンロードできます。',
    originSimplifiedTooltip:
      'このバージョンはアプリが冗長なソリッドを 1 つのボディに結合して提案した CAD 簡略化案です。「候補」とはあなたの承認待ちの意味 — 他は何も変更されておらず、承認後にアクティブジオメトリに昇格します。拒否すれば前のバージョンが維持されます。',
    expand: '展開',
    collapse: '折りたたむ',
    previewAsCad: 'CAD テッセレーションでプレビュー',
    previewCadActive: 'CAD テッセレーションを表示中 — クリックで自動プレビュー',
    downloadSourceFile: 'ソースファイルをダウンロード',
    downloadMesh: 'メッシュをダウンロード',
    directionInternal: '内部',
    directionExternal: '外部',
    meshStatusLabel: 'メッシュのステータス: {{status}}',
    noSourceFile:
      'このバージョンにダウンロード可能なソースファイルはありません。',
    downloadSourceFailed:
      'ソースファイルをダウンロードできませんでした — もう一度お試しください。',
  },
  meshControls: {
    resultsTitle: 'メッシュ結果',
    startStudy: 'SimOps研究を開始',
  },
  upload: {
    uploading: '新しいバージョンをアップロード中…',
    uploaded:
      '新しいバージョンをアップロードしました — 新しい Diagnosis を実行中',
    failed: 'アップロードに失敗しました — もう一度お試しください',
  },
} as const;
